import axios from "../axios-auth";

export const stockTakeService = {
    getStockTakeData,
    getAllStockTake,
    register
}

function getStockTakeData(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.warehouseId) {
        params["warehouseId"] = searchParams.warehouseId;
    }
    if (searchParams.barcode) {
        params["barcode"] = searchParams.barcode;
    }
    if (searchParams.brandId) {
        params["brandId"] = searchParams.brandId;
    }
    if (searchParams.categoryId) {
        params["categoryId"] = searchParams.categoryId;
    }

    return axios.get("/auth/get-stock-take-data", { params });
}

function getAllStockTake(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.createdDate) {
        params["createdDate"] = searchParams.createdDate;
    }
    if (searchParams.warehouseId) {
        params["warehouseId"] = searchParams.warehouseId;
    }
    if (searchParams.barcode) {
        params["barcode"] = searchParams.barcode;
    }
    if (searchParams.brandId) {
        params["brandId"] = searchParams.brandId;
    }
    if (searchParams.categoryId) {
        params["categoryId"] = searchParams.categoryId;
    }

    return axios.get("/auth/get-all-stock-take", { params });
}

function register() {
    return axios.post("/auth/stock-take")
}